
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { EAvatarSize } from './enums/avatar-size';
import AvatarFallback from './assets/avatar-fallback.svg';

@Component({
  name: 'BaseAvatar',
  components: {
    AvatarFallback,
  },
})
export default class BaseAvatar extends Vue {
  @Prop() thumbUrl?: string;
  @Prop() name: string;
  @Prop({ default: EAvatarSize.Medium }) size: EAvatarSize;

  thumbError = false;
  imageLoaded = false;

  get initials(): string {
    const names: string[] = this.name.split(' ');

    if (names.length === 1) {
      return names[0].toUpperCase().substring(0, 2);
    }

    let initials = '';
    names.forEach((name: string) => {
      initials += name[0] || '';
    });
    return initials.toUpperCase().substring(0, 3);
  }

  get characterCodes(): number {
    const charCodes = this.initials
      .split('')
      .map(char => char.charCodeAt(0))
      .join('');
    return parseInt(charCodes, 10);
  }

  get backgroundClass(): string {
    const classes: string[] = [
      'leather',
      'wood',
      'forest',
      'emerald',
      'ocean',
      'olive',
      'purple',
      'pink',
      'rose',
      'lilac',
    ];
    return classes[this.characterCodes % classes.length];
  }

  handleThumbError() {
    this.thumbError = true;
  }
  handleImageLoad() {
    this.imageLoaded = true;
  }
}
